import { useEffect, useState } from "react";
import { BiCalendar } from "react-icons/bi";
import { PiUsersThreeBold } from "react-icons/pi";
import { TbZoomMoney } from "react-icons/tb";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import StudentsModal from "src/components/StudentsModal";
import { useAuth } from "src/contexts/auth";
import { useStudent } from "src/contexts/student";
import api from "src/rest/api";
import styled from "styled-components";
import ChangeLogCard from "./ChangelogCard";
import InfoCard from "./InfoCard";
import NotificationsCard from "./NotificationsCard";
import SubscriptionWarning from "./SubscriptionWarning";
import ToolsCard from "./ToolsCard";

import "./styles.css";

export const Card = styled.div`
  flex: 1;
  height: 100%;
  border-radius: 5px;
  background-color: white;
  padding: 10px;
  border: 2px solid #ddd;
`;

export const CardButton = styled.button`
  flex: 1;
  height: 100%;
  border-radius: 5px;
  background-color: white;
  padding: 10px;
  border: 2px solid #ddd;

  cursor: pointer;

  transition: border 0.1s;

  :active {
    border: 2px solid #888;
  }
`;

const DashboardGrid = () => {
  const [alunos, setAlunos] = useState(false);

  const info = useQuery(
    "userinfo",
    () =>
      api
        .post<{
          students: number;
          schedules: number;
        }>("/dashboard/getinfo")
        .then((res) => res.data)
        .catch((err) => {
          throw new Error(err);
        }),
    { staleTime: 300 * 1000 },
  );

  useEffect(() => {
    student.onSetStudent(undefined);
  }, []);

  const auth = useAuth();

  const student = useStudent();

  const navigate = useNavigate();

  return (
    <div className="fade-in m-auto mx-auto grid w-full max-w-[1366px] grid-cols-1 grid-rows-[auto,1fr] items-center md:gap-4 md:p-6 lg:grid-cols-3">
      <StudentsModal active={alunos} setActive={setAlunos} />

      {auth.subscribed && <SubscriptionWarning flag={auth.subscribed} />}

      {/* Primeira linha */}
      <div className="h-[150px] min-h-[150px] p-2">
        <InfoCard
          Icon={PiUsersThreeBold}
          amount={info.data?.students || 0}
          subtitle={"Alunos"}
          onClick={() => setAlunos(true)}
        />
      </div>
      <div className="h-[150px] min-h-[150px] p-2">
        <InfoCard
          Icon={BiCalendar}
          amount={info.data?.schedules || 0}
          subtitle={"Atividades Hoje"}
          onClick={() => navigate("/calendar")}
        />
      </div>
      <div className="h-[150px] min-h-[150px] p-2">
        <InfoCard
          Icon={TbZoomMoney}
          amount={0}
          subtitle={"Financeiro"}
          onClick={() => navigate("/checkout")}
        />
      </div>

      {/* Segunda linha */}
      <div className="h-[100%] overflow-y-auto p-2 md:h-[400px]">
        <ToolsCard />
      </div>
      <div className="h-[100%] overflow-y-auto p-2 md:h-[400px]">
        <NotificationsCard />
      </div>
      <div className="h-[100%] overflow-y-auto p-2 md:h-[400px]">
        <ChangeLogCard />
      </div>
    </div>
  );
};

export default DashboardGrid;
